import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { NAV, CONTACT, CORE_SERVICES } from "@/data/site";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden border-t-2 border-[#B39A62]/30" style={{ background: "#121E30", color: "#F7F4EE" }} data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 pt-20 lg:pt-28 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/brand/logo.png" alt="Arun Gupta & Co. logo" className="h-16 w-16 object-contain" />
              <div>
                <div className="font-serif text-3xl leading-none">Arun Gupta &amp; Co.</div>
                <div className="overline mt-2" style={{ color: "#B39A62" }}>Chartered Accountants</div>
              </div>
            </div>
            <p className="font-serif italic text-2xl mt-8 max-w-sm" style={{ color: "#F7F4EE" }}>
              Built on experience.<br />Forward in perspective.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="overline" style={{ color: "#B39A62" }}>Explore</div>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-sm text-ivory/75 hover:text-ivory transition-colors duration-300 link-underline"
                    data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline" style={{ color: "#B39A62" }}>Services</div>
            <ul className="mt-5 space-y-3">
              {CORE_SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services#${s.id}`}
                    className="text-sm text-ivory/75 hover:text-ivory transition-colors duration-300 link-underline"
                    data-testid={`footer-service-${s.id}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="overline" style={{ color: "#B39A62" }}>Kanpur Office</div>
            <address className="mt-5 not-italic text-sm text-ivory/75 leading-relaxed">
              {CONTACT.addressLines.map((l) => (
                <span key={l} className="block">{l}</span>
              ))}
            </address>
            <div className="mt-5 space-y-1.5 text-sm">
              {CONTACT.phones.map((p) => (
                <a key={p} href={`tel:${p.replace(/\s+/g, "")}`} className="block text-ivory/75 hover:text-ivory transition-colors" data-testid={`footer-phone-${p.replace(/\D/g, "")}`}>
                  {p}
                </a>
              ))}
              <a href={`mailto:${CONTACT.email}`} className="block text-ivory/75 hover:text-ivory transition-colors" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </div>
            <a
              href={CONTACT.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 whitespace-nowrap text-sm text-ivory/75 hover:text-ivory transition-colors"
              data-testid="footer-linkedin"
            >
              <Linkedin size={16} strokeWidth={1.5} />
              <span className="link-underline">LinkedIn</span>
              <ArrowUpRight size={13} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="mt-16 lg:mt-24" style={{ height: "1px", background: "rgba(247,244,238,0.14)" }} />
        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-ivory/55 tracking-wide">
            © {year} Arun Gupta &amp; Co. Chartered Accountants. All rights reserved.
          </p>
          <p className="text-xs text-ivory/40 tracking-wide">Kanpur, Uttar Pradesh, India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
